import { render, staticRenderFns } from "./BillboardHome.vue?vue&type=template&id=0e059bc7&scoped=true&"
import script from "./BillboardHome.vue?vue&type=script&lang=ts&"
export * from "./BillboardHome.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e059bc7",
  null
  
)

export default component.exports